export const initialValues = {
    calculationRules: 'base_rate + commission + spread',
    commission: {
        value: '',
    },
    config: {
        limit: {
            value: '',
        },
        paymentChannels: [],
    },
};
